import React from 'react';
import { DataTable, Field } from '../../commons/DataTable';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../commons/Auth';

function OfficesTable({ profile, data, total, offset, limit, onFilter }) {
  const [t] = useTranslation('OFFICES');
  const [{ newIsAdmin } = {}] = useAuth();

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field title="Codice ufficio" source="code" />
      <Field title="Ufficio" source="office" />
      <Field title="Ragione Sociale" source="businessName" />
      <Field title="Associazione" source="profile.businessName" visible={newIsAdmin || profile.type !== 'ASSOCIATION'} />
      <Field title="Codice Fiscale Associazione" source="profile.fiscalCode" visible={newIsAdmin || profile.type !== 'ASSOCIATION'} />
      <Field title="Referente ufficio" source="contactPerson" />
      <Field title="Pec" source="email" />
      <Field title="Cellulare" source="cell" />
      <Field title="Indirizzo" source="address" />
    </DataTable>
  );
}

export default OfficesTable;
